<script setup>
import { onMounted, ref, nextTick } from 'vue';

const emit = defineEmits(['clickAccordionGa']);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  classPrefix: {
    type: String,
    required: false,
  },
  focusAndScroll: {
    type: Boolean,
    default: false,
    required: false,
  },
});

const isOpened = ref(props.isOpen);
const buttonRef = ref(null);

onMounted(() => {
  if (props.focusAndScroll) {
    isOpened.value = true;
    nextTick(() => {
      buttonRef.value.focus();
      buttonRef.value.scrollIntoView(true, { behavior: 'smooth' });
    });
  }
});

function handleClick() {
  isOpened.value = !isOpened.value;
  if (isOpened.value) {
    emit('clickAccordionGa');
  }
}
</script>

<template>
  <h3>
    <button
      class="c-accordion__item-heading-btn"
      :class="`${classPrefix}item-heading-btn`"
      :aria-controls="id"
      :aria-expanded="isOpened"
      @click="handleClick"
      ref="buttonRef"
    >
      <slot name="heading" />
      <span class="c-accordion__icon--chevron" :class="{ 'is-open': isOpened }">
        <svg
          aria-hidden="true"
          focusable="false"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.7393 5L12.0276 13.7942L3.20551 5.05786L1 7.31427L11.9173 18.5385L23 7.42998L20.7393 5Z"
          />
        </svg>
      </span>
    </button>
  </h3>
  <div
    class="c-accordion__content"
    :class="{ 'is-open': isOpened }"
    :aria-hidden="!isOpened"
    :id="id"
  >
    <slot name="content" />
  </div>
</template>